export const messages = {
  title: {
    id: 'admin/promotions.list.actions.template.title',
  },
  subtitle: {
    id: 'admin/promotions.list.actions.template.subtitle',
  },
  cancel: {
    id: 'admin/promotions.utils.cancel',
  },
  save: {
    id: 'admin/promotions.utils.save',
  },
  name: {
    id: 'admin/promotions.form.general.name',
  },
  description: {
    id: 'admin/promotions.list.actions.template.description',
  },
  budgetWarning: {
    id: 'admin/promotions.list.actions.template.budget.warning',
  },
  saveTemplate: {
    error: {
      id: 'admin/promotions.list.actions.template.save.template.error',
    },
    success: {
      id: 'admin/promotions.list.actions.template.save.template.success',
    },
  },
  deleteTemplate: {
    error: {
      id: 'admin/promotions.list.actions.template.delete.template.error',
    },
    success: {
      id: 'admin/promotions.list.actions.template.delete.template.success',
    },
  },
  validation: {
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
